// Mock数据拦截器
// 当接口未开发时，使用本地mock数据
import axios from 'axios';

// 是否启用Mock数据（开发环境默认启用）
const useMock = process.env.VUE_APP_USE_MOCK !== 'false';

// Mock数据集合
const mockData = {
  // 首页轮播图
  '/home/banner': {
    code: 200,
    data: [
      {
        id: 1,
        imageUrl: 'https://picsum.photos/1920/600?random=1',
        title: '医院文化',
        link: '/hospital-intro'
      },
      {
        id: 2,
        imageUrl: 'https://picsum.photos/1920/600?random=2',
        title: '医院动态',
        link: '/hospital-dynamic'
      }
    ],
    message: '成功'
  },

  // 首页医院新闻
  '/home/news': {
    code: 200,
    data: {
      list: [
        {
          id: 1,
          date: '2025-11-26',
          title: '知名专家门诊,12月4日华东师范大学附属精神卫生中心(上海市长宁区精神卫生中心) 精神科专家来我院坐诊',
          summary: '我院特邀上海知名专家前来坐诊，为患者提供更优质的医疗服务',
          imageUrl: 'https://picsum.photos/400/300?random=3'
        },
        {
          id: 2,
          date: '2025-11-18',
          title: '提升监测能力筑牢安全防线——————池州市第三人民医院成功举办药械安全性监测专题培训',
          summary: '为进一步加强我院药品和医疗器械安全性监测工作，提升医务人员的安全意识',
          imageUrl: 'https://picsum.photos/400/300?random=4'
        },
        {
          id: 3,
          date: '2025-11-12',
          title: '喜报!我院护理人员在省、市两级专业培训中屡创佳绩',
          summary: '近日，我院护理人员在省、市两级专业培训中屡创佳绩，展现出优秀的专业素养与进取精神',
          imageUrl: 'https://picsum.photos/400/300?random=5'
        },
        {
          id: 4,
          date: '2025-11-11',
          title: '2025年下半年全市精神科医疗质量监测及严重精神障碍管理治疗项目专项督导检查',
          summary: '为切实加强我市精神卫生专业医疗质量控制，提高全市精神科疾病规范化诊疗水平',
          imageUrl: 'https://picsum.photos/400/300?random=6'
        },
        {
          id: 5,
          date: '2025-11-03',
          title: '喜讯!我院药师在"药健康进万家—《健康之光，阳帆起航》"短视频竞赛中冲进全国赛',
          summary: '近日，在2025"药健康进万家—《健康之光，阳帆起航》"短视频科普能力大赛中，我院吴佳俊药师成功突围',
          imageUrl: 'https://picsum.photos/400/300?random=7'
        }
      ],
      total: 50,
      page: 1,
      pageSize: 10
    },
    message: '成功'
  },

  // 通知公告
  '/home/notices': {
    code: 200,
    data: {
      list: [
        {
          id: 1,
          date: '2025-11-21',
          day: '21',
          month: '11',
          year: '2025',
          title: '喜报！我院护理人员在省、市两级专业培训中屡创佳绩',
          content: '近日，我院护理人员在省、市两级专业培训中屡创佳绩'
        },
        {
          id: 2,
          date: '2025-11-18',
          day: '18',
          month: '11',
          year: '2025',
          title: '市三院开展"情暖夕阳红"巾帼志愿服务 用心关爱老年人',
          content: '为弘扬尊老敬老的传统美德，我院开展志愿服务活动'
        },
        {
          id: 3,
          date: '2025-11-10',
          day: '10',
          month: '11',
          year: '2025',
          title: '市三院赴九华山风景区中心学校开展儿童青少年情绪管理讲座',
          content: '为促进儿童青少年心理健康，我院专家团队走进校园'
        },
        {
          id: 4,
          date: '2025-11-04',
          day: '04',
          month: '11',
          year: '2025',
          title: '喜报！我院护理人员在省、市两级专业培训中屡创佳绩',
          content: '我院护理团队在专业培训中表现优异'
        }
      ],
      total: 30,
      page: 1,
      pageSize: 10
    },
    message: '成功'
  },

  // 医院概况
  '/home/hospital/overview': {
    code: 200,
    data: {
      title: '池州市第三人民医院',
      description: '池州市第三人民医院（精神病专科医院），隶属市卫生健康委员会，列全额拨款、公益二类事业单位，正处级建制。是池州市唯一集医疗、预防、康复、教学、科研功能于一体的二级精神病专...',
      imageUrl: 'https://picsum.photos/800/500?random=8'
    },
    message: '成功'
  },

  // 科室列表
  '/home/departments': {
    code: 200,
    data: [
      {
        id: 1,
        name: '老年精神科',
        category: '临床科室',
        description: '专注于老年精神疾病的诊疗'
      },
      {
        id: 2,
        name: '焦虑抑郁障碍科',
        category: '特色专科',
        description: '专业治疗焦虑抑郁症'
      },
      {
        id: 3,
        name: '儿童青少年心理科',
        category: '特色专科',
        description: '关注儿童青少年心理健康'
      },
      {
        id: 4,
        name: '睡眠障碍科',
        category: '特色专科',
        description: '专业治疗各类睡眠障碍'
      },
      {
        id: 5,
        name: '中医心理门诊',
        category: '特色专科',
        description: '中西医结合治疗'
      },
      {
        id: 6,
        name: '超声科',
        category: '医技科室',
        description: '提供专业超声检查服务'
      },
      {
        id: 7,
        name: '药剂科',
        category: '医技科室',
        description: '负责药品管理与配发'
      },
      {
        id: 8,
        name: '放射科',
        category: '医技科室',
        description: '提供影像检查服务'
      }
    ],
    message: '成功'
  },

  // 医生风采
  '/home/doctors': {
    code: 200,
    data: [
      {
        id: 1,
        name: '董学武',
        title: '主治医师',
        department: '精神科',
        specialty: '中共党员',
        qualification: '主治医师，心理咨询师三级',
        description: '池州市心理学学会会员，在贵池区未成年保护中心兼职',
        imageUrl: 'https://picsum.photos/300/400?random=9'
      },
      {
        id: 2,
        name: '张晓明',
        title: '副院长',
        department: '精神科',
        specialty: '精神科专家',
        qualification: '主任医师',
        description: '从事精神科临床工作30余年，经验丰富',
        imageUrl: 'https://picsum.photos/300/400?random=10'
      },
      {
        id: 3,
        name: '程明霞',
        title: '护士长',
        department: '护理部',
        specialty: '优秀护理工作者',
        qualification: '主管护师',
        description: '荣获"优秀讲师"及"健康教育先锋"称号',
        imageUrl: 'https://picsum.photos/300/400?random=11'
      }
    ],
    message: '成功'
  },

  // 医院动态列表
  '/news/dynamic': {
    code: 200,
    data: {
      list: [
        {
          id: 1,
          date: '2025-11-25',
          day: '25',
          month: '11',
          year: '2025',
          title: '以练为战 防患未"燃" ——市第三人民医院圆满完成消防宣传月灭火与应急疏散演练',
          summary: '为筑牢安全防线，积极响应全国第34个消防宣传月"全民消防、生命至上——安全用火用电"主题，11月28日下午，市三院组织开展了一场实战化的灭火与应急疏散演练，旨在全面提升全院职工的消防安全意识和应急处置能力，切实保障患者、家属及医务人员的生命财产安全。',
          imageUrl: 'https://picsum.photos/600/400?random=12'
        },
        {
          id: 2,
          date: '2025-11-25',
          day: '25',
          month: '11',
          year: '2025',
          title: '知名专家门诊，12月4日华东师范大学附属精神卫生中心（上海市长宁区精神卫生中心）精神科专家来我院坐诊',
          summary: '为了更好地服务广大患者，我院特邀上海知名精神科专家前来坐诊。',
          imageUrl: 'https://picsum.photos/600/400?random=13'
        },
        {
          id: 3,
          date: '2025-11-25',
          day: '25',
          month: '11',
          year: '2025',
          title: '提升监测能力 筑牢安全防线 ——池州市第三人民医院成功举办药械安全性监测专题培训',
          summary: '为进一步加强我院药品和医疗器械安全性监测工作，提升医务人员的安全意识和报告质量，切实保障患者医疗安全，11月17日下午，我院特邀市药品不良反应监测中心主任钱贵娟一行，来院开展业务指导和专题培训。来自医药护技以及后勤保障等科室的70余名骨干人员参加，院党委委员王胜出席并致辞。',
          imageUrl: 'https://picsum.photos/600/400?random=14'
        },
        {
          id: 4,
          date: '2025-11-25',
          day: '25',
          month: '11',
          year: '2025',
          title: '喜报！我院护理人员在省、市两级专业培训中屡创佳绩',
          summary: '近日，我院护理人员在省、市两级专业培训中屡创佳绩，展现出优秀的专业素养与进取精神。在2025年"第五届安徽省精神卫生专科护士培训班"学习中，我院选派的程明霞同志表现突出，荣获"优秀讲师"及"健康教育先锋"称号。',
          imageUrl: 'https://picsum.photos/600/400?random=15'
        }
      ],
      total: 100,
      page: 1,
      pageSize: 10
    },
    message: '成功'
  },

  // 新闻详情
  '/news/detail': {
    code: 200,
    data: {
      id: 1,
      date: '2025-11-26',
      title: '知名专家门诊，12月4日华东师范大学附属精神卫生中心（上海市长宁区精神卫生中心）精神科专家来我院坐诊',
      content: `
        <p>为了更好地服务广大患者，满足患者日益增长的医疗需求，我院特邀上海知名精神科专家前来坐诊。</p>
        <p><strong>专家介绍：</strong></p>
        <p>本次来院坐诊的专家来自华东师范大学附属精神卫生中心（上海市长宁区精神卫生中心），在精神疾病诊疗领域有着深厚的造诣和丰富的临床经验。</p>
        <p><strong>坐诊时间：</strong>2025年12月4日</p>
        <p><strong>预约方式：</strong>请提前拨打医院预约电话0566-3386000进行预约</p>
        <p>我院将继续为患者提供优质的医疗服务，欢迎广大患者前来就诊。</p>
      `,
      author: '宣传科',
      publishDate: '2025-11-26',
      viewCount: 256,
      publisher: '宣传科',
      images: ['https://picsum.photos/800/500?random=16'],
      prevArticle: '提升监测能力 筑牢安全防线',
      nextArticle: '喜报！我院护理人员在省、市两级专业培训中屡创佳绩'
    },
    message: '成功'
  },

  // 医院简介
  '/hospital/intro': {
    code: 200,
    data: {
      title: '池州市第三人民医院',
      subtitle: '（精神病专科医院）',
      introduction: '池州市第三人民医院（精神病医院），隶属市卫生健康委员会，列全额拨款、公益二类事业单位，正处级建制。是池州市唯一集医疗、预防、康复、教学、科研功能于一体的二级精神病专科医院，主要职责是以患者为中心，开展与医院功能定位相适应的诊疗服务，推广应用临床新技术新项目，保障医疗质量和医疗安全。',
      images: [
        'https://picsum.photos/600/400?random=30',
        'https://picsum.photos/600/400?random=31',
        'https://picsum.photos/600/400?random=32',
        'https://picsum.photos/600/400?random=33'
      ]
    },
    message: '成功'
  },

  // 医院领导
  '/hospital/leaders': {
    code: 200,
    data: [
      {
        id: 1,
        name: '张晓明',
        position: '院长',
        title: '主任医师',
        imageUrl: 'https://picsum.photos/300/400?random=17',
        introduction: '从事精神科临床工作30余年，主持多项省市级科研项目，在精神疾病诊疗方面有深入研究。'
      },
      {
        id: 2,
        name: '段小玲',
        position: '党委书记',
        title: '副主任医师',
        imageUrl: 'https://picsum.photos/300/400?random=18',
        introduction: '长期从事医院管理和党建工作，致力于医院文化建设和职工队伍建设。'
      }
    ],
    message: '成功'
  },

  // 科室列表（支持分页）
  '/hospital/departments': {
    code: 200,
    data: [
      { id: 1, name: '医学心理科', updateTime: '2024-12-11' },
      { id: 2, name: '老年精神科', updateTime: '2024-12-11' },
      { id: 3, name: '六病区', updateTime: '2024-12-11' },
      { id: 4, name: '七病区', updateTime: '2024-12-11' },
      { id: 5, name: '八病区', updateTime: '2024-12-11' },
      { id: 6, name: '九病区', updateTime: '2024-12-11' },
      { id: 7, name: '焦虑抑郁障碍科', updateTime: '2024-12-10' },
      { id: 8, name: '儿童青少年心理科', updateTime: '2024-12-10' },
      { id: 9, name: '睡眠障碍科', updateTime: '2024-12-09' },
      { id: 10, name: '中医心理门诊', updateTime: '2024-12-09' },
      { id: 11, name: '超声科', updateTime: '2024-12-08' },
      { id: 12, name: '药剂科', updateTime: '2024-12-08' },
      { id: 13, name: '放射科', updateTime: '2024-12-07' },
      { id: 14, name: '检验科', updateTime: '2024-12-07' },
      { id: 15, name: '心脑电图室', updateTime: '2024-12-06' },
      { id: 16, name: '物理治疗中心', updateTime: '2024-12-06' },
      { id: 17, name: '办公室', updateTime: '2024-12-05' },
      { id: 18, name: '人事科', updateTime: '2024-12-05' },
      { id: 19, name: '财务科', updateTime: '2024-12-04' },
      { id: 20, name: '医务科', updateTime: '2024-12-04' },
      { id: 21, name: '护理部', updateTime: '2024-12-03' },
      { id: 22, name: '后勤保障科', updateTime: '2024-12-03' }
    ],
    message: '成功'
  },

  // 医疗设备（富文本内容）
  '/hospital/equipment': {
    code: 200,
    data: {
      content: `
        <div class="equipment-section">
          <h2>医疗设备介绍</h2>
          <p>池州市第三人民医院配备有先进的医疗设备，为精准诊断和有效治疗提供了强有力的技术支撑。</p>
        </div>

        <div class="equipment-section">
          <h3>检验设备</h3>
          <ul>
            <li><strong>全自动生化分析仪</strong>：用于血液生化指标的快速检测，提高诊断效率</li>
            <li><strong>全自动凝血分析仪</strong>：用于凝血功能检测，保障手术安全</li>
            <li><strong>全自动免疫分析仪</strong>：用于免疫学检测，辅助疾病诊断</li>
            <li><strong>全自动血液分析仪</strong>：用于血常规检测，快速准确</li>
            <li><strong>干式生化分析仪</strong>：便携式生化检测设备，操作简便</li>
            <li><strong>细菌药敏分析仪</strong>：用于细菌培养和药敏试验</li>
            <li><strong>全自动尿液分析系统</strong>：用于尿液常规检测</li>
            <li><strong>五分类血细胞分析仪</strong>：用于血细胞分类计数</li>
          </ul>
        </div>

        <div class="equipment-section">
          <h3>影像设备</h3>
          <ul>
            <li><strong>X光机（DR）</strong>：数字化X射线摄影系统，图像清晰，辐射剂量低</li>
            <li><strong>64排螺旋CT</strong>：高分辨率CT扫描，用于全身各部位检查</li>
            <li><strong>彩色超声诊断仪（GE、三星）</strong>：用于腹部、心脏、血管等检查</li>
            <li><strong>医用红外热像仪</strong>：用于体表温度检测和疾病筛查</li>
          </ul>
        </div>

        <div class="equipment-section">
          <h3>心理治疗设备</h3>
          <ul>
            <li><strong>心理压力分析仪</strong>：用于心理压力评估和分析</li>
            <li><strong>心理CT</strong>：心理测评系统，辅助心理疾病诊断</li>
            <li><strong>智能心理宣泄系统</strong>：帮助患者进行情绪宣泄</li>
            <li><strong>智能互动宣泄仪</strong>：互动式心理治疗设备</li>
            <li><strong>计算机化认知行为治疗系统</strong>：辅助认知行为治疗</li>
            <li><strong>虚拟现实心理健康训练系统</strong>：VR技术应用于心理治疗</li>
            <li><strong>生物反馈治疗仪</strong>：通过生物反馈进行心理治疗</li>
            <li><strong>音乐治疗仪</strong>：音乐疗法设备，舒缓患者情绪</li>
          </ul>
        </div>

        <div class="equipment-section">
          <h3>物理治疗设备</h3>
          <ul>
            <li><strong>脑功能治疗仪</strong>：用于脑功能康复治疗</li>
            <li><strong>无抽搐电休克治疗仪</strong>：用于精神疾病的物理治疗</li>
            <li><strong>经颅磁刺激仪</strong>：非侵入性脑刺激治疗设备</li>
            <li><strong>经颅电刺激仪</strong>：经颅电刺激治疗设备</li>
            <li><strong>经颅超声神经肌肉刺激治疗仪</strong>：用于神经肌肉康复</li>
            <li><strong>中频治疗仪</strong>：中频电疗设备</li>
            <li><strong>脑波治疗仪</strong>：脑电波治疗设备</li>
            <li><strong>光疗系统</strong>：光疗设备，用于季节性情感障碍等疾病</li>
            <li><strong>空气波压力循环治疗仪</strong>：用于肢体循环治疗</li>
            <li><strong>功率自行车</strong>：康复训练设备</li>
            <li><strong>医用慢速跑台</strong>：康复训练设备</li>
          </ul>
        </div>

        <div class="equipment-section">
          <h3>其他设备</h3>
          <ul>
            <li><strong>超声骨密度仪</strong>：用于骨密度检测</li>
            <li><strong>全自动推片机</strong>：用于血液涂片制备</li>
            <li><strong>干式荧光免疫分析仪</strong>：用于免疫荧光检测</li>
            <li><strong>诱发电位仪</strong>：用于神经电生理检查</li>
          </ul>
        </div>

        <div class="equipment-section">
          <h3>设备优势</h3>
          <p>我院医疗设备先进齐全，涵盖了检验、影像、心理治疗、物理治疗等多个领域，能够满足各类疾病的诊断和治疗需求。所有设备均经过严格的质量控制和定期维护，确保设备运行稳定、检测结果准确可靠。</p>
          <p>医院注重设备的更新换代和人才培养，定期组织医护人员进行设备操作培训，确保每台设备都能发挥最大效能，为患者提供优质的医疗服务。</p>
        </div>
      `
    },
    message: '成功'
  },

  // 视频中心
  '/videos/list': {
    code: 200,
    data: {
      list: [
        {
          id: 1,
          title: '医院宣传片',
          coverImage: 'https://picsum.photos/640/360?random=19',
          videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
          duration: '05:30',
          publishDate: '2025-11-01',
          views: 1250
        },
        {
          id: 2,
          title: '健康科普：如何应对焦虑症',
          coverImage: 'https://picsum.photos/640/360?random=20',
          videoUrl: 'https://www.w3schools.com/html/movie.mp4',
          duration: '08:15',
          publishDate: '2025-10-25',
          views: 860
        },
        {
          id: 3,
          title: '医院活动回顾',
          coverImage: 'https://picsum.photos/640/360?random=21',
          videoUrl: 'https://www.w3schools.com/html/mov_bbb.mp4',
          duration: '06:45',
          publishDate: '2025-10-15',
          views: 520
        }
      ],
      total: 20,
      page: 1,
      pageSize: 10
    },
    message: '成功'
  }
};

// 创建mock axios实例拦截器
if (useMock) {
  // 拦截请求，返回mock数据
  const originalRequest = axios.request;
  axios.request = function(config) {
    const url = config.url;

    // 检查是否有对应的mock数据
    for (const mockUrl in mockData) {
      // 支持动态路由参数，如 /news/detail/1
      const urlPattern = new RegExp('^' + mockUrl.replace(/\//g, '\\/'));
      if (urlPattern.test(url)) {
        console.log(`[Mock] 拦截请求: ${url}, 返回mock数据`);

        // 模拟网络延迟
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({ data: mockData[mockUrl] });
          }, 300 + Math.random() * 500); // 300-800ms的随机延迟
        });
      }
    }

    // 如果没有mock数据，则执行真实请求
    return originalRequest.call(this, config);
  };

  console.log('[Mock] Mock数据服务已启用');
}

export default mockData;
